var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ClientSideEncryption = /** @class */ (function () {
    function ClientSideEncryption(key) {
        var _this = this;
        this.encrypt = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var aesKey, iv, encryptedData, encodedKey, keyData, encryptedKey, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, window.crypto.subtle.generateKey({ name: 'AES-GCM', length: 256 }, true, ['encrypt', 'decrypt'])];
                    case 1:
                        aesKey = _d.sent();
                        iv = window.crypto.getRandomValues(new Uint8Array(12));
                        return [4 /*yield*/, window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, aesKey, Buffer.from(JSON.stringify(data)))];
                    case 2:
                        encryptedData = _d.sent();
                        return [4 /*yield*/, window.crypto.subtle.exportKey('raw', aesKey)];
                    case 3:
                        encodedKey = _d.sent();
                        keyData = {
                            key: Buffer.from(encodedKey).toString('base64'),
                            iv: Buffer.from(iv).toString('base64')
                        };
                        _b = (_a = window.crypto.subtle).encrypt;
                        _c = [{ name: 'RSA-OAEP' }];
                        return [4 /*yield*/, this.publicKey];
                    case 4: return [4 /*yield*/, _b.apply(_a, _c.concat([_d.sent(), Buffer.from(JSON.stringify(keyData))]))];
                    case 5:
                        encryptedKey = _d.sent();
                        return [2 /*return*/, Buffer.from(JSON.stringify({
                                encryptedData: Buffer.from(encryptedData).toString('base64'),
                                encryptedKey: Buffer.from(encryptedKey).toString('base64')
                            })).toString('base64')];
                }
            });
        }); };
        this.publicKey = window.crypto.subtle.importKey('spki', Buffer.from(key, 'base64'), { name: 'RSA-OAEP', hash: 'SHA-256' }, true, ['encrypt']);
    }
    return ClientSideEncryption;
}());
export { ClientSideEncryption };
